import * as React from "react";
import {
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbList as ShadcnBreadcrumbList,
  BreadcrumbItem as ShadcnBreadcrumbItem,
  BreadcrumbLink as ShadcnBreadcrumbLink,
  BreadcrumbPage as ShadcnBreadcrumbPage,
  BreadcrumbSeparator as ShadcnBreadcrumbSeparator,
  BreadcrumbEllipsis as ShadcnBreadcrumbEllipsis,
} from "@/components/shadcn/breadcrumb";
import { cn } from "@/lib/utils";

export const Breadcrumb = (props: React.ComponentProps<typeof ShadcnBreadcrumb>) => (
  <ShadcnBreadcrumb {...props} />
);

export const BreadcrumbList = (props: React.ComponentProps<typeof ShadcnBreadcrumbList>) => (
  <ShadcnBreadcrumbList
    {...props}
    className={cn("text-white text-md font-medium flex gap-1 md:gap-1 items-center", props.className)}
  />
);

export const BreadcrumbItem = (props: React.ComponentProps<typeof ShadcnBreadcrumbItem>) => (
  <ShadcnBreadcrumbItem {...props} />
);

export const BreadcrumbLink = (props: React.ComponentProps<typeof ShadcnBreadcrumbLink>) => (
  <ShadcnBreadcrumbLink
    {...props}
    className={cn("text-white text-md font-medium hover:text-white/80 transition-colors", props.className)}
  />
);

export const BreadcrumbPage = (props: React.ComponentProps<typeof ShadcnBreadcrumbPage>) => (
  <ShadcnBreadcrumbPage
    {...props}
    className={cn("text-white text-md font-medium", props.className)}
  />
);

export const BreadcrumbSeparator = (props: React.ComponentProps<typeof ShadcnBreadcrumbSeparator>) => (
  <ShadcnBreadcrumbSeparator
    {...props}
    className={cn("text-white text-md font-medium mx-2 select-none", props.className)}
  >
    {props.children ?? "/"}
  </ShadcnBreadcrumbSeparator>
);

export const BreadcrumbEllipsis = (props: React.ComponentProps<typeof ShadcnBreadcrumbEllipsis>) => (
  <ShadcnBreadcrumbEllipsis {...props} />
);
